import type { ReactNode } from "react";
import { cn } from "@/modern/utils";
import { ENTITY_FINDER_ROW_PADDING, ENTITY_FINDER_SUBTITLE_CLS, ENTITY_FINDER_TITLE_CLS } from "@/modern/components/entity-finder/constants/layout";

export function entityFinderTintText(tint: string): string {
  return tint.split(" ").find((c) => c.startsWith("text-")) ?? "";
}

export function entityFinderIconShellClass(hasSubtitle: boolean, iconColorClass?: string) {
  return cn(
    "flex size-8 shrink-0 items-center justify-center rounded-lg bg-background ring-1 ring-border/60 shadow-sm",
    hasSubtitle && "mt-0.5",
    iconColorClass
  );
}

export function entityFinderRowClass(hasSubtitle: boolean) {
  return cn(
    "flex w-full gap-3",
    ENTITY_FINDER_ROW_PADDING,
    hasSubtitle ? "items-start" : "items-center"
  );
}

interface EntityFinderItemRowProps {
  icon: ReactNode;
  iconClassName?: string;
  title: ReactNode;
  subtitle?: ReactNode;
  trailing?: ReactNode;
  className?: string;
}

export function EntityFinderItemRow({
  icon,
  iconClassName,
  title,
  subtitle,
  trailing,
  className,
}: EntityFinderItemRowProps) {
  const hasSubtitle = Boolean(subtitle);

  return (
    <div className={cn(entityFinderRowClass(hasSubtitle), className)}>
      <div className={entityFinderIconShellClass(hasSubtitle, iconClassName)}>{icon}</div>
      <div className="min-w-0 flex-1">
        <div className={cn("truncate", ENTITY_FINDER_TITLE_CLS)}>{title}</div>
        {subtitle ? (
          <p className={cn("mt-0.5 truncate", ENTITY_FINDER_SUBTITLE_CLS)}>{subtitle}</p>
        ) : null}
      </div>
      {trailing ? <div className={cn("shrink-0", hasSubtitle && "mt-0.5")}>{trailing}</div> : null}
    </div>
  );
}
